const env = import.meta.env;

/** Modalità demo: dati finti in memoria, nessun login. Mai in produzione. */
export const DEMO = __DEMO__;

function required(name: keyof ImportMetaEnv): string {
  const v = env[name];
  if (!v && !DEMO) throw new Error(`Variabile di configurazione mancante: ${name}`);
  return v ?? "";
}

export const config = {
  clientId: required("VITE_ENTRA_CLIENT_ID"),
  tenantId: required("VITE_ENTRA_TENANT_ID"),
  graphScopes: (
    env.VITE_GRAPH_SCOPES ??
    "https://graph.microsoft.com/User.Read,https://graph.microsoft.com/Sites.ReadWrite.All,https://graph.microsoft.com/GroupMember.Read.All"
  )
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean),
  apiBaseUrl: env.VITE_API_BASE_URL?.replace(/\/$/, "") || undefined,
  apiScope: env.VITE_API_SCOPE || undefined,
  siteUrl: env.VITE_SITE_URL || (DEMO ? "https://demo.sharepoint.com/sites/Applicazioni" : undefined),
  devSiteUrl: env.VITE_DEV_SITE_URL || undefined,
  groups: {
    gestori: env.VITE_GROUP_GESTORI_ID || (DEMO ? "demo-gestori" : undefined),
    coordinatori: env.VITE_GROUP_COORDINATORI_ID || (DEMO ? "demo-coordinatori" : undefined),
  },
} as const;
